import React from "react";
import { useTinyHost } from "@tiny/host-contract";
import { SegmentIdentityView1 } from "@tiny/api";
import { usePostSegmentStatisticsTotalQuery } from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";

export function useAudienceSourceAll() {
  const { navigate } = useTinyHost();

  const {
    data: segmentDetails,
    refetch: refetchSegmentStatistics,
    isLoading,
  } = usePostSegmentStatisticsTotalQuery();

  useRefreshRegister(async () => {
    await refetchSegmentStatistics();
  });

  const gotoAudienceDetails = React.useCallback(
    (segment: SegmentIdentityView1) => {
      navigate.to("/main/audience");
    },
    [navigate]
  );

  return {
    segmentDetails,
    gotoAudienceDetails,
    refetchSegmentStatistics,
    isLoading,
  };
}
